//project
import Project from "@/views/project/project";
import projectTitle from "@/views/project/content/titleBlock/projectTitle";

import { ItemAttachment, Relationship, PageInfo } from "./commonModules";

export const ProjectPage = {
  path: "/project",
  // component: () => import('@/views/project/project'),
  component: Project,
  children: [
    {
      path: "/projectTitle",
      // component: () => import('@/views/project/content/titleBlock/projectTitle')},
      component: projectTitle,
    },
    {
      path: "/projectSchedule",
      component: () => import("@/views/project/content/schedule/schedule"),
    },
    {
      path: "/projectTeam",
      component: () => import("@/views/project/content/team"),
    },
    {
      path: "/projectScheduleComments",
      component: () =>
        import("@/views/project/content/projectScheduleComments"),
    },

    // {	path: '/projectWorkflow',
    // 	component: () => import('@/views/project/content/workflow/workflow')},
    {
      path: "/ProjectAttachment",
      name: "ProjectAttachment",
      component: ItemAttachment,
    },

    {
      path: "/projectDeliverable",
      component: () => import("@/views/project/content/deliverable"),
    },
    {
      path: "/projectWorkflowInformation",
      component: () => import("@/views/project/content/workflowInformation"),
    },
    {
      path: "/projectHistory",
      component: () => import("@/views/project/content/history"),
    },
  ],
};
